import { colors } from '@creditsights/styleguide-web';

enum Period {
  VERY_LOW = 'VERY_LOW',
  LOW = 'LOW',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH',
  VERY_HIGH = 'VERY_HIGH',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

const getPeriod = (value: number): Period => {
  switch (true) {
    case value <= 20:
      return Period.VERY_LOW;
    case value > 20 && value <= 40:
      return Period.LOW;
    case value > 40 && value <= 60:
      return Period.MODERATE;
    case value > 60 && value <= 80:
      return Period.HIGH;
    case value > 80:
      return Period.VERY_HIGH;
    default:
      return Period.NOT_AVAILABLE;
  }
};

const cqsColorConfig: Record<Period, string> = {
  [Period.VERY_LOW]: colors.high100,
  [Period.LOW]: colors.high50,
  [Period.MODERATE]: colors.moderate,
  [Period.HIGH]: colors.low50,
  [Period.VERY_HIGH]: colors.low100,
  [Period.NOT_AVAILABLE]: colors.tertiary300,
};

export const getCqsColor = (value: number): string => cqsColorConfig[getPeriod(value)];

const DEFAULT_FRACTION_DIGITS = 6;

export const convertToPercentage = (value: number, fractionDigits = DEFAULT_FRACTION_DIGITS): number =>
  Number((value * 100).toFixed(fractionDigits));
